//@flow
import StockRemindersStore from './stockRemindersStoreClass';

export default new StockRemindersStore();
